import { render } from "./RedirectModal.vue?vue&type=template&id=4f2c016c&scoped=true&lang=pug"
import script from "./RedirectModal.vue?vue&type=script&lang=js"
export * from "./RedirectModal.vue?vue&type=script&lang=js"

import "./RedirectModal.vue?vue&type=style&index=0&id=4f2c016c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2c016c"]])

export default __exports__